module.exports = __webpack_public_path__ + "img/new-attendee-img.07abcd30.jpg";